import { useEffect, useState } from "react";
import { loadCategories } from "./constants";
import { comboboxOption } from "./constants";
export const useCategories = () => {
  const [supplierOptions, setSupplierOptions] = useState<comboboxOption[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await loadCategories();
      setSupplierOptions(data);
    };

    fetchData();
  }, []);

  return supplierOptions;
};